<template>
      <h1>{{name }}</h1>

</template>

<script>
    export default {
      data(){
        return{
          name:"brownwang"
        }
      },
      beforeRouteEnter:((to, from, next) =>{
        // alert("hello "+this.name);
        // next();
        next((vm => {
          alert("hello "+vm.name);
        }))
      }),
      beforeRouteLeave:((to, from, next) => {
        if(confirm("确定离开？")==true){
          next()
        }else{
          next(false)
        }
      })
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin.vue